import { atom } from "recoil";

export const addStateEmailRecipient = atom({
  key: "addStateEmailRecipient",
  default: false,
});
export const editStateEmailRecipient = atom({
  key: "editStateEmailRecipient",
  default: false,
});
export const rowEditIdState = atom({
  key: "rowEditIdStateEmailRecipient",
  default: null,
});
export const disableButtonStateEmailRecipient = atom({
  key: "disableButtonStateEmailRecipient",
  default: false,
});

export const selectedRowsStateEmailRecipient = atom({
  key: "selectedRowsStateEmailRecipient",
  default: [],
});
